import $ from 'jquery';
export default class VideoModalButton {
    static animationSpeed = 300;
    static initializedDataKey = 'videoModalButtonInitialized';
    static modalKeydownEvent = 'keydown.videoModal';
    static init($root = $('body')) {
        const $element = $root.find('.js__video-modal-button');
        $element.each((_, element) => {
            const $button = $(element);
            if ($button.data(this.initializedDataKey)) {
                return;
            }
            $button.data(this.initializedDataKey, true);
            $button.on('click', event => {
                event.preventDefault();
                this.openFileVideoModal($button.prop('href'), $button.attr('aria-label') || '');
            });
        });
    }
    static openFileVideoModal(videoUrl, ariaLabel) {
        this.closeActiveModal();
        const modalId = `modal-video-${Date.now().toString(36)}`;
        const $modal = $(`
      <div class="modal-video">
        <div class="modal-video-body">
          <div class="modal-video-inner" id="modal-video-inner-${modalId}">
            <div class="modal-video-movie-wrap" style="padding-bottom:56.25%">
              <button class="modal-video-close-btn js-modal-video-dismiss-btn" aria-label="Close video"></button>
              <video class="modal-video-file" controls autoplay playsinline preload="metadata">
                <source src="${videoUrl}">
              </video>
            </div>
          </div>
        </div>
      </div>
    `);
        const $modalMovieWrap = $modal.find('.modal-video-movie-wrap');
        const $closeButton = $modal.find('.js-modal-video-dismiss-btn');
        $modal
            .attr({
            id: modalId,
            tabindex: -1,
            role: 'dialog',
            'aria-label': ariaLabel || '',
        })
            .appendTo('body')
            .trigger('focus');
        $modalMovieWrap.on('click', event => {
            event.stopPropagation();
        });
        const closeModal = () => {
            $modal.addClass('modal-video-close');
            $(window).off(this.modalKeydownEvent);
            window.setTimeout(() => {
                $modal.remove();
            }, this.animationSpeed);
        };
        $(window)
            .off(this.modalKeydownEvent)
            .on(this.modalKeydownEvent, (event) => {
            if (event.key === 'Escape') {
                closeModal();
            }
        });
        $modal.on('click', closeModal);
        $closeButton.on('click', event => {
            event.stopPropagation();
            closeModal();
        });
    }
    static closeActiveModal() {
        $('.modal-video').remove();
        $(window).off(this.modalKeydownEvent);
    }
}
